interface Option {
  label: string;
  value: string;
}

interface FilterPanelProps {
  genres: string[];
  years: string[];
  regions: string[];
  selectedGenres: string[];
  selectedYear: string;
  selectedRegion: string;
  onToggleGenre: (genre: string) => void;
  onSelectYear: (year: string) => void;
  onSelectRegion: (region: string) => void;
  onReset: () => void;
}

function FilterGroup({
  title,
  options,
  activeValues,
  onClick,
}: {
  title: string;
  options: Option[];
  activeValues: string[];
  onClick: (value: string) => void;
}) {
  return (
    <div className="border-t border-background-200 py-5 first:border-t-0 first:pt-0">
      <h3 className="mb-3 text-sm font-semibold text-foreground-900">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = activeValues.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onClick(opt.value)}
              className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                active
                  ? "bg-primary-600 text-background-50"
                  : "border border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  genres,
  years,
  regions,
  selectedGenres,
  selectedYear,
  selectedRegion,
  onToggleGenre,
  onSelectYear,
  onSelectRegion,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-base font-bold text-foreground-950">筛选条件</h2>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <FilterGroup
        title="类型"
        options={genres.map((g) => ({ label: g, value: g }))}
        activeValues={selectedGenres}
        onClick={onToggleGenre}
      />
      <FilterGroup
        title="年份"
        options={[{ label: "全部", value: "all" }, ...years.map((y) => ({ label: y, value: y }))]}
        activeValues={[selectedYear]}
        onClick={onSelectYear}
      />
      <FilterGroup
        title="地区"
        options={[{ label: "全部", value: "all" }, ...regions.map((r) => ({ label: r, value: r }))]}
        activeValues={[selectedRegion]}
        onClick={onSelectRegion}
      />
    </div>
  );
}